/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { IBasket } from '../Context/AppListContext';
import fetchCall from '../utils/fetchCall';
import { formEndpoint } from '../utils/formEndpoint';


export const useEnquiryCheckout = () => {
  const [response, setResponse] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

   const submitEnquiry = React.useCallback(async (formData: any, basket: IBasket, token: string) => {
    try {
      setLoading(true);
      setError(null);
      setResponse(null);
      const body = {
        basket, 
        data: formData,
        token
      }
      const res = await fetchCall({
        url: formEndpoint('demo'),
        method: 'POST',
        data: body,
        headers: { 'Content-Type': 'application/json' },
      });
      setLoading(false);
// if success
      setResponse(res);
    } catch (e: any) {
      setLoading(false);
      setError(e?.message || 'Operation failed');
    }

  }, []);

  return { submitEnquiry, response, loading, error, setResponse };

}
